import { Component, Input, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSnackBar } from '@angular/material';
import { EditEventShortDescriptionComponent } from '../edit-event-short-description/edit-event-short-description.component';

@Component({
  selector: 'app-event-short-description',
  templateUrl: './event-short-description.component.html',
  styleUrls: ['./event-short-description.component.scss']
})
export class EventShortDescriptionComponent implements OnInit {
  @Input() aviationEvent: AviationEvent;
  editModeSet = false;

  constructor(private _editDescDialog: MatDialog,
              public snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  openEditDescDialog() {
    const DATA = {aviationEvent: this.aviationEvent};
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '800px';
    dialogConfig.data = DATA;

    const DIALOG_REF = this._editDescDialog.open(EditEventShortDescriptionComponent, dialogConfig);
    this._handleModalClose(DIALOG_REF);
  }

  /**
   * listens for dialog close event. Opens snackbar if necessary
   * @param {MatDialogRef<any>} dialogRef
   * @private
   */
  _handleModalClose ( dialogRef: MatDialogRef<any>) {
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';

    dialogRef.afterClosed().subscribe((success) => {
      if (success === null) { return; }
      if (success) {
        this.snackBar.open('Event Short Description', 'Updated', {
          duration: 3000
        });
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }

}
